import React from 'react';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { useDisclosure } from '../../hooks/useDisclosure/useDisclosure.es.js';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'nanoid/non-secure';
import { Box } from '../../primitives/Box/Box.es.js';
import { IconButton } from '../IconButton/IconButton.es.js';
import { Drawer } from '../Drawer/Drawer.es.js';
import '../../assets/icons/custom/CheckIcon.es.js';
import '../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../assets/icons/generated/filled/CdPauseFilled.es.js';
import '../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../assets/icons/generated/filled/LockFilled.es.js';
import '../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../assets/icons/generated/filled/StarFilled.es.js';
import '../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../assets/icons/generated/filled/StopFilled.es.js';
import '../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../assets/icons/generated/filled/XFilled.es.js';
import '../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../assets/icons/generated/outlined/CancelOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockOutlined.es.js';
import '../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../assets/icons/generated/outlined/FeatherOutlined.es.js';
import '../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../assets/icons/generated/outlined/MailOutlined.es.js';
import MenuInvertedOutlined from '../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../assets/icons/generated/outlined/MobilePhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../assets/icons/generated/outlined/ThreadOutlined.es.js';
import '../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../assets/icons/generated/products/Blog.es.js';
import '../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../assets/icons/generated/products/Chromatic.es.js';
import '../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../assets/icons/generated/products/Courses.es.js';
import '../../assets/icons/generated/products/Creator.es.js';
import '../../assets/icons/generated/products/Distribution.es.js';
import '../../assets/icons/generated/products/Insider.es.js';
import '../../assets/icons/generated/products/LandrFx.es.js';
import '../../assets/icons/generated/products/Mastering.es.js';
import '../../assets/icons/generated/products/NetworkPro.es.js';
import '../../assets/icons/generated/products/NetworkServices.es.js';
import '../../assets/icons/generated/products/Network.es.js';
import '../../assets/icons/generated/products/Plugins.es.js';
import '../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../assets/icons/generated/products/SamplesDark.es.js';
import '../../assets/icons/generated/products/Samples.es.js';
import '../../assets/icons/generated/products/SessionsDark.es.js';
import '../../assets/icons/generated/products/Sessions.es.js';
import '../../assets/icons/generated/products/Tutorials.es.js';
import '../../assets/icons/generated/products/Vocalign.es.js';
import { NavBarContext } from './context.es.js';

const NavBarDrawer = ({ brand, menu, menuLabel }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return /* @__PURE__ */ React.createElement(NavBarContext.Provider, {
    value: { closePanel: onClose }
  }, /* @__PURE__ */ React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ React.createElement(IconButton, {
    label: menuLabel,
    icon: MenuInvertedOutlined,
    kind: "minimal",
    variant: "subtle",
    onClick: onOpen,
    size: "sm",
    isRounded: true,
    hideTooltip: true,
    mr: "xxs"
  }), /* @__PURE__ */ React.createElement(Drawer, {
    side: "left",
    isVisible: isOpen,
    onClose
  }, /* @__PURE__ */ React.createElement(Drawer.Content, null, /* @__PURE__ */ React.createElement(Box, {
    mb: "lg"
  }, brand), menu))));
};

export { NavBarDrawer };
//# sourceMappingURL=NavBarDrawer.es.js.map
